export default {
  attendeesData: [],
};
